import { LocationUTM } from '~types/Location.types';

const UTM_KEYS = Object.values(LocationUTM);

function isUtm(value: any, values: LocationUTM[]): value is LocationUTM {
  return values.includes(value);
}

type Props = {
  url?: string;
  values?: LocationUTM[];
};

export function getUtmFromUrl({ url, values = UTM_KEYS }: Props = {}):
  | Partial<Record<LocationUTM, string>>
  | undefined {
  const location = url ? new URL(url) : window.location;
  const { search } = location;
  const params = new URLSearchParams(search);
  const dataArr = Array.from(params).filter(([value]) => isUtm(value, values));

  return dataArr.length ? Object.fromEntries(dataArr) : undefined;
}
